'use strict';

const { creatorById } = require('dibs-endpoints');
const { addHeaders, fetchWrapper } = require('dibs-service-fetch-wrappers/dist/util');

function fetchCreators(ac, { creatorIds }, done) {
    if (creatorIds && creatorIds.length) {
        const requests = creatorIds.map(creatorId => {
            // No-fail promise -- always resolve so the Promise.all never rejects
            return new Promise(resolve => {
                fetchWrapper(creatorById(creatorId), addHeaders({ method: 'get' }))
                    .then(resolve)
                    // Resolve, even on failed call -- otherwise the Promise.all will reject and no creators will load
                    .catch(() => {
                        resolve(null);
                    });
            });
        });

        Promise.all(requests)
            .then(responses => {
                ac.dispatch(
                    'ADD_CREATORS',
                    responses.filter(response => !!response).map(({ result }) => result)
                );
                done();
            })
            .catch(done);
    }
}

module.exports = {
    fetchCreators,
};



// WEBPACK FOOTER //
// ./assets/js/global/actions/creatorsActions.es.js